import { useQuery } from "@apollo/client/react";
import UIStateContext from "contexts/UIStateContext";
import { GetWorkOrder } from "hooks/apollo/workOrder/workOrder.gql";
import useSlideOutState from "hooks/state/useSlideOutState";
import Authorization from "policies/Authorization";
import React, { useContext, useEffect } from "react";
import WorkOrderDetailsView from "./WorkOrderDetailsView";

export default function WorkOrderDetailsContainer() {
  const slideOutState = useSlideOutState();
  const visible = slideOutState.isWorkOrderMode();

  const { setState: updateUIState, getState: getUIState } = useContext(UIStateContext);

  const { workOrderDetailsSectionsOpen } = getUIState();
  const toggleSectionState = (sectionKey) => () => {
    const { workOrderDetailsSectionsOpen: currentState } = getUIState();
    const state = currentState[sectionKey];
    const newState = { ...currentState, [sectionKey]: !state };
    updateUIState({ workOrderDetailsSectionsOpen: newState });
  };

  const policy = Authorization.usePolicy();
  const canUpdateWorkOrder = policy.canUpdate(Authorization.EntityTypes.WorkOrder);

  const { data, loading } = useQuery(GetWorkOrder, {
    fetchPolicy: "network-only",
    skip: !slideOutState.workOrderId,
    variables: { id: slideOutState.workOrderId },
  });

  // biome-ignore lint/correctness/useExhaustiveDependencies: including slideOutState affects our ability to close sidebar
  useEffect(() => {
    const code = data?.workOrder.code;
    if (code) {
      slideOutState.setWorkOrderCode(code);
    }
  }, [data]);

  const workOrder = data?.workOrder;

  if (loading || !workOrder || !visible) return null;

  return (
    <WorkOrderDetailsView
      initialSectionOpenState={workOrderDetailsSectionsOpen}
      readonly={!canUpdateWorkOrder}
      toggleSectionState={toggleSectionState}
      workOrder={workOrder}
    />
  );
}
